import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <div style={{ padding: '4rem 1.5rem', maxWidth: '900px', margin: '0 auto' }}>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h1 style={{
                    fontSize: '2.5rem',
                    fontWeight: 'bold',
                    color: 'var(--color-secondary)',
                    marginBottom: '1rem',
                    textAlign: 'center'
                }}>
                    About Synapse Tutors
                </h1>

                <div style={{
                    height: '4px',
                    width: '80px',
                    background: 'var(--color-accent)',
                    margin: '0 auto 3rem',
                    borderRadius: '2px'
                }}></div>

                <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444', marginBottom: '2rem' }}>
                    <p style={{ marginBottom: '1.5rem' }}>
                        In the Middle East, accessing <strong>world-class academic tutoring</strong> has always been a challenge.
                        While countless tutoring services exist globally, finding <em>high-quality, subject-specialist tutors</em> who
                        understand British curriculum requirements—especially for GCSE and A-Levels—proved nearly impossible.
                    </p>

                    <p style={{ marginBottom: '1.5rem' }}>
                        As a parent navigating this landscape myself, I spent <strong>months searching</strong> for the right tutors
                        for my children. The process was <em>exhausting</em>: vetting credentials, scheduling trial sessions, dealing
                        with inconsistent quality, and facing premium prices without guaranteed results.
                    </p>

                    <p style={{ marginBottom: '1.5rem' }}>
                        That's when <span style={{ color: 'var(--color-primary)', fontWeight: '600' }}>Synapse Tutors</span> was born.
                    </p>

                    <p style={{ marginBottom: '1.5rem' }}>
                        We built Synapse to solve the exact problem I faced: <strong>connecting families in the Middle East with
                            exceptional British-curriculum tutors</strong> from top UK universities. Every tutor is carefully vetted,
                        degree-verified, and experienced in delivering results.
                    </p>

                    <p style={{ marginBottom: '1.5rem' }}>
                        No more endless searching. No more uncertainty. Just <strong>expert tutors</strong>, <strong>proven
                            methodologies</strong>, and <strong>measurable progress</strong>—delivered conveniently online, tailored
                        to your child's needs.
                    </p>

                    <div style={{
                        background: 'var(--color-teal-light)',
                        padding: '2rem',
                        borderRadius: '12px',
                        borderLeft: '4px solid var(--color-primary)',
                        marginTop: '2.5rem'
                    }}>
                        <p style={{
                            fontSize: '1.2rem',
                            fontWeight: '600',
                            color: 'var(--color-primary)',
                            marginBottom: '0.5rem'
                        }}>
                            Our Mission
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            To make world-class British curriculum education accessible to every student in the Middle East,
                            eliminating the frustration of finding quality tutors and ensuring every child has the support they
                            need to excel academically.
                        </p>
                    </div>
                </div>

                <div style={{ marginTop: '3rem', textAlign: 'center' }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '1.5rem', color: 'var(--color-secondary)' }}>
                        Ready to Get Started?
                    </h2>
                    <Link
                        to="/#contact"
                        className="button-primary"
                        style={{
                            display: 'inline-block',
                            padding: '1rem 2rem',
                            fontSize: '1.1rem',
                            textDecoration: 'none'
                        }}
                    >
                        Contact Us Today
                    </Link>
                </div>
            </motion.div>
        </div>
    );
};

export default About;
